import PropTypes from 'prop-types';
/* eslint-disable react/no-find-dom-node */
import React from "react";
import ReactDOM from "react-dom";

import autobind from "autobind-decorator";

export default class TouchHandler extends React.Component {
    static propTypes = {
        selected: PropTypes.number.isRequired,
        select: PropTypes.func.isRequired,
        expose: PropTypes.func.isRequired,
        children: PropTypes.node
    };

    @autobind
    _handleScroll({target}) {
        let sel = target.scrollLeft / window.innerWidth;
        if (sel % 1 === 0 && sel !== this.props.selected) {
            this.props.select(sel);
        }
    }

    @autobind
    _handleGesture({type, scale}) {
        let zoom =  document.documentElement.clientWidth / window.innerWidth;
        if (type === "gesturestart") {
            this._zoom = zoom;
        }else if (type =="gestureend"){
            if (zoom <= 1 && this._zoom * scale <= 0.9) {
                this.props.expose(true);
            }
        }
    }

    componentDidMount() {
        let el = ReactDOM.findDOMNode(this);
        el.addEventListener("scroll", this._handleScroll);
        el.addEventListener("gesturestart", this._handleGesture);
        el.addEventListener("gestureend", this._handleGesture);
        this.componentDidUpdate({});
    }

    componentDidUnmount() {
        let el = ReactDOM.findDOMNode(this);
        el.removeEventListener("scroll", this._handleScroll);
        el.removeEventListener("gesturestart", this._handleGesture);
        el.removeEventListener("gestureend", this._handleGesture);
    }

    componentDidUpdate(prevProps) {
        let selected = this.props.selected;
        if (prevProps.selected !== selected) {
            ReactDOM.findDOMNode(this).scrollLeft = selected * document.documentElement.clientWidth;
        }
    }

    render() {
        return this.props.children;
    }
}


// WEBPACK FOOTER //
// ./src/kpi/common/TouchHandler.js